/* NegoStore — logica popup-ului de newsletter.
   Se ocupa de: deschidere dupa age gate, o singura data pe sesiune,
   retragere definitiva dupa abonare, copiere cod. */
(function () {
  'use strict';

  var SESSION_KEY = 'nego-newsletter-session';
  var DONE_KEY = 'nego-newsletter-done';

  // NegoStore (perf 09.10.2026): popup-ul nu mai fura atingerea clientului. Pana acum se deschidea fix
  // la ageDelay / fallbackDelay, chiar daca clientul era in mijlocul unei actiuni (observat: a prins o
  // atingere pe butonul Filtre la ~12 s). Acum, la momentul programat:
  // - BLOCKING: overlay-urile full-screen ale temei (aceeasi lista ca OVERLAY_SELECTOR din nego-chat.js,
  //   plus sertarul de cos si modalele temei). Peste ele nu deschidem deloc; reverificam la RETRY_MS
  //   pana se inchid, fara plafon.
  // - amanare cu plafon: o atingere / tasta / derulare in ultimele QUIET_MS sau panoul de chat deschis.
  //   Dupa MAX_RETRIES amanari deschidem oricum, ca popup-ul sa apara.
  var BLOCKING = '.popup.popup-open, [id^="cb-overlay-"].cb-open, .aside-menu--open, body.nego-facets-open, ' +
    'body.overflow-hidden, body.overflow-hidden-drawer, body.overflow-hidden-modal';
  var SOFT = '[data-nego-chat].is-open';
  var QUIET_MS = 2000;
  var RETRY_MS = 4000;
  var MAX_RETRIES = 5;

  function read(store, key) {
    try { return window[store].getItem(key); } catch (e) { return null; }
  }

  function write(store, key) {
    try { window[store].setItem(key, '1'); } catch (e) {}
  }

  // NegoStore (perf 25.09.2026): scriptul e acum defer, deci ruleaza posibil inainte
  // ca popup.js sa lege declansatorul manual (in jQuery(document).ready); un
  // trigger.click() prea devreme (ramura 'posted') cadea in gol si codul nu mai aparea.
  // jQuery ruleaza callback-urile de ready in ordinea inregistrarii, iar popup.js
  // (defer in <head>) se inregistreaza inaintea noastra, deci jQuery(fn) vine dupa el.
  function onReady(fn) {
    if (window.jQuery) {
      window.jQuery(fn);
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function bindCopy() {
    if (window.negoCopyBound) return;
    window.negoCopyBound = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-nego-copy]') : null;
      if (!btn) return;

      var code = btn.getAttribute('data-nego-copy');
      var hint = btn.querySelector('.nego-code__hint');
      var done = function () {
        if (!hint) return;
        hint.textContent = btn.getAttribute('data-copied-label') || '';
        setTimeout(function () {
          hint.textContent = btn.getAttribute('data-copy-label') || '';
        }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () {});
      } else {
        var tmp = document.createElement('textarea');
        tmp.value = code;
        document.body.appendChild(tmp);
        tmp.select();
        try { document.execCommand('copy'); done(); } catch (err) {}
        document.body.removeChild(tmp);
      }
    });
  }

  function setup(root) {
    if (root.negoReady) return;
    root.negoReady = true;

    var sectionId = root.getAttribute('data-id');
    var trigger = document.querySelector('.nego-newsletter-trigger[data-nego-for="' + sectionId + '"]');
    var fallbackDelay = parseInt(root.getAttribute('data-nego-fallback-delay'), 10);
    var ageDelay = parseInt(root.getAttribute('data-nego-age-delay'), 10);
    var posted = root.getAttribute('data-nego-posted') === 'true';
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    if (isNaN(fallbackDelay)) fallbackDelay = 6000;
    if (isNaN(ageDelay)) ageDelay = 800;

    function destroy() {
      var overlay = root.nextElementSibling;
      if (overlay && overlay.classList.contains('popup-overlay') && overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
      if (root.parentNode) root.parentNode.removeChild(root);
      if (trigger && trigger.parentNode) trigger.parentNode.removeChild(trigger);
    }

    // NegoStore (perf 09.10.2026): o singura deschidere pe pagina. Click-ul pe "Da" poate ajunge de doua ori
    // (atingerea reala + reluarea ei de catre popup.js la DCL), iar cu cookie-ul de varsta scris de poarta
    // inainte de DCL ruleaza si ramura de vizitator care revine. Fara garda, a doua deschidere o redeschidea
    // pe cea pe care clientul tocmai o inchisese.
    var opened = false;
    var queued = false;
    var lastInput = 0;
    var INPUT_EVENTS = ['pointerdown', 'keydown'];

    // atingerea pe "Da" din poarta nu conteaza: dupa ea popup-ul vine dinadins (ageDelay)
    function markInput(e) {
      var t = e && e.target;
      if (t && t.closest && t.closest('.age-verification')) return;
      lastInput = Date.now();
    }

    function trackInput(on) {
      var fn = on ? 'addEventListener' : 'removeEventListener';
      for (var i = 0; i < INPUT_EVENTS.length; i++) window[fn](INPUT_EVENTS[i], markInput, true);
      // doar derularea paginii; derularile din interiorul altor elemente nu ajung aici
      window[fn]('scroll', markInput, { passive: true });
    }

    function open() {
      if (opened || !trigger) return;
      opened = true;
      trackInput(false);
      write('sessionStorage', SESSION_KEY);
      trigger.click();
    }

    function tryOpen(left) {
      queued = false;
      if (opened || root.classList.contains('popup-open')) return;
      // poarta deschisa fara raspuns: nu deschidem peste ea; "Da" programeaza deschiderea din nou.
      // Daca "Da" a scris deja cookie-ul, poarta doar isi termina iesirea (0,5 s): o prinde BLOCKING
      // (.popup.popup-open) si reincercam. Altfel, cu age_delay 0 din editor, popup-ul nu mai venea deloc.
      if (ageGateOpen() && !ageAccepted()) return;
      // cat timp un overlay blocheaza nu consumam amanarile: altfel, dupa un sertar tinut deschis cu
      // atingeri in el, popup-ul ar aparea la cateva secunde dupa inchidere, peste urmatoarea atingere
      var blocked = !!document.querySelector(BLOCKING);
      var soft = !blocked && left > 0 && (Date.now() - lastInput < QUIET_MS || !!document.querySelector(SOFT));
      if (blocked || soft) {
        queued = true;
        setTimeout(function () { tryOpen(soft ? left - 1 : left); }, RETRY_MS);
        return;
      }
      open();
    }

    // Numaram de la jQuery ready: abia atunci popup.js a legat declansatorul manual. Un timer pornit
    // mai devreme (atingere pe "Da" inainte de DCL) ar fi apasat declansatorul in gol.
    // NegoStore (perf 09.10.2026): la verificare - daca popup.js a legat deja declansatorul (negoPopupReady,
    // pus imediat dupa init; asa vine si reluarea lui "Da" de la DCL), pornim ceasul pe loc, ca inainte.
    // Prin jQuery(fn) treceam printr-un setTimeout in plus, care pe un telefon ocupat imediat dupa DCL
    // intarzia popup-ul cu 0,5-1 s fata de tema veche.
    function schedule(delay) {
      if (opened || queued) return;
      queued = true;
      var start = function () {
        setTimeout(function () { tryOpen(MAX_RETRIES); }, delay);
      };
      if (window.negoPopupReady) start();
      else onReady(start);
    }

    function ageGateEl() {
      return document.querySelector('.age-verification');
    }

    function ageGateOpen() {
      return !!document.querySelector('.age-verification.popup-open');
    }

    // Cookie-ul de varsta este specific sectiunii din TEMA CURENTA.
    // Fara aceasta verificare, un cookie ramas de la alta tema ar face
    // popup-ul sa se deschida peste age gate.
    function ageAccepted() {
      var gate = ageGateEl();
      if (!gate) return true;
      var id = gate.getAttribute('data-id');
      if (!id) return false;
      return document.cookie.indexOf('popup-age-' + id + '=1') !== -1;
    }

    function bindAgeGate() {
      document.addEventListener('click', function (e) {
        var yes = e.target.closest ? e.target.closest('.age-verification__popup-close') : null;
        if (!yes) return;
        schedule(ageDelay);
      });
    }

    if (designMode) {
      onReady(function () { setTimeout(open, 400); });
      return;
    }

    // Tocmai s-a abonat: redeschide ca sa vada codul, apoi nu mai apare niciodata.
    if (posted) {
      write('localStorage', DONE_KEY);
      write('sessionStorage', SESSION_KEY);
      onReady(function () {
        setTimeout(function () { if (trigger) trigger.click(); }, 400);
      });
      return;
    }

    // Deja abonat sau deja vazut in aceasta sesiune: scoate-l din pagina.
    if (read('localStorage', DONE_KEY) || read('sessionStorage', SESSION_KEY)) {
      destroy();
      return;
    }

    trackInput(true);

    // NegoStore (perf 09.10.2026): si cand "Da" a fost atins inainte de DCL. Poarta a scris deja cookie-ul,
    // dar popup.js reia click-ul la DCL (data-nego-early-click), deci asteptam click-ul ca pana acum si
    // pastram intarzierea de dupa varsta (ageDelay), nu pe cea de vizitator care revine.
    var gate = ageGateEl();
    if (gate && (!ageAccepted() || gate.getAttribute('data-nego-early-click') === 'yes')) {
      bindAgeGate();
      return;
    }

    // Vizitator care revine: age gate-ul nu mai apare, deci deschidem cu intarziere.
    // (tryOpen nu deschide peste poarta daca e totusi deschisa, ca inainte.)
    bindAgeGate();
    schedule(fallbackDelay);
  }

  function init() {
    bindCopy();
    var roots = document.querySelectorAll('.nego-newsletter');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  init();

  document.addEventListener('shopify:section:load', function () {
    var roots = document.querySelectorAll('.nego-newsletter');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  });
})();